import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle (t "tuition_assistance.default")}}
  {{outlet}}
</template>
